<script>
import baseMixin from '@mixins/baseMixin'
import OutstandingInvoiceAlert from '@/components/invoices/outstanding-invoice-alert.vue'
import TheDebugBar from '@components/dev/the-debug-bar.vue'
import TheNavDrawer from '@components/layout/the-nav-drawer.vue'
import TheTopBar from '@components/layout/the-top-bar.vue'
import TheImpersonateBar from '@/components/impersonate/the-impersonate-bar.vue'
import ServiceStatusAlert from '@/components/app/service-status-alert.vue'

export default {
  components: {
    OutstandingInvoiceAlert,
    TheDebugBar,
    TheNavDrawer,
    TheTopBar,
    TheImpersonateBar,
    ServiceStatusAlert,
  },
  mixins: [baseMixin],
  props: {
    noGutters: {
      type: Boolean,
    },
  },
  data() {
    return {
      drawer: null,
    }
  },
  computed: {
    compXAxisPadding() {
      switch (true) {
        case this.isLarge:
        case this.isMedium:
          return 'px-8'
        case this.isSmallOrLower:
          return 'px-2'
        default:
          return ''
      }
    },
  },
  mounted() {
    // Init drawer state on mobile to be closed
    this.drawer = !this.isMobileViewPort
  },
}
</script>

<template>
  <v-app id="client-login">
    <TheDebugBar />
    <TheImpersonateBar />
    <TheNavDrawer :drawer="drawer" @setDrawerState="drawer = $event" />
    <TheTopBar @toggleDrawer="drawer = !drawer" />
    <v-main class="mainDiv">
      <ServiceStatusAlert />
      <v-container
        :class="['fill-height', noGutters ? 'ma-0 pa-0' : '', compXAxisPadding]"
        :fluid="isLargeOrLower"
        style="margin-bottom: 100px"
      >
        <v-layout>
          <v-flex xs12 sm12 md12>
            <OutstandingInvoiceAlert />
            <slot />
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>
